<template lang="html">
<b-form class="form-horizontal" @submit.prevent="submitForm">
  <b-card no-body>
    <b-tabs card>
      <b-tab active>
        <template slot="title">
          <tab-item icon="list" heading="Step 1" subheading="Details"></tab-item>
        </template>
        <b-container fluid>
          <b-row>


            <b-col md="3">
              <strong>File</strong>
              <p class="muted">Enter the general details of this file here.</p>
              <p class="muted">After a file is saved, the contract's <strong>Start Date</strong> and <strong>End Date</strong> will be changed to reflect this file.</p>
            </b-col>

            <b-col md="9">

              <b-form-group label="File Type" label-class="font-weight-bold" :class="{ 'invalid-group': $v.form.contractFileTypeId.$error }">
                <b-form-select id="fileTypes" v-model="form.contractFileTypeId" :options="fileTypes" value-field="contractFileTypeId" text-field="contractFileTypeLabel"></b-form-select>
                <span class="span-feedback invalid-feedback" v-if="$v.form.contractFileTypeId.$error">Please select a file type.</span>
              </b-form-group>

              <b-form-group label="Start Date"
                            label-class="control-label"
                            :class="{ 'invalid-group': $v.form.startDate.$error }">
                  <datepicker v-model="form.startDate"
                              :inputClass="{ 'form-control': true }"
                              typeable="true"
                              format="MM/dd/yyyy"></datepicker>
                  <span class="span-feedback invalid-feedback" v-if="$v.form.startDate.$error">Please enter a start date.</span>
              </b-form-group>
              
              <b-form-group label="End Date"
                            label-class="control-label"
                            :class="{ 'invalid-group': $v.form.endDate.$error }">
                  <datepicker v-model="form.endDate"
                              :inputClass="{ 'form-control': true }"
                              typeable="true"
                              format="MM/dd/yyyy"></datepicker>
                  <span class="span-feedback invalid-feedback" v-if="$v.form.endDate.$error">Please enter a start date.</span>
              </b-form-group>

              <b-form-group label="File" label-class="control-label" :class="{ 'invalid-group': $v.selectedFile.$error }">
                    <b-form-file id="file-input" 
                                 v-model="selectedFile" 
                                 placeholder="Choose a file..." 
                                 class="file-input"
                                 aria-describedby="file-feedback"></b-form-file>                    
                    <span class="span-feedback invalid-feedback" v-if="$v.selectedFile.$error">Please select a file to upload.</span>
                </b-form-group>

            </b-col>

          </b-row>
        </b-container>
      </b-tab>
    </b-tabs>
  </b-card>
<b-button class="btn-primary pull-right save-contract-button" @click="saveFile()">Save</b-button>
</b-form>
</template>

<script>
import TabItem from "../menu/tab-item";
import toastr from "toastr";
import ToastrSettings from "../../settings/toastr-settings";
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import contractApi from "../../api/contracts";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars

export default {
  name: "contract-form",
  props: {
    contractId: {
      required: true
    },
    fileTypes: {
      type: Array,
      required: true
    }
  },
  mounted() {},
  data() {
    return {
      form: {
        contractId: 0,
        contractFileId: 0,
        contractFileTypeId: null,
        startDate: null,
        endDate: null
      },
      selectedFile: null
    };
  },

  validations: function() {
    var validate = {
      form: {
        contractFileTypeId: {
          required
        },
        startDate: {
          required
        },
        endDate: {
          required
        }
      },
      selectedFile: {
        required
      }
    };
    return validate;
  },

  methods: {
    saveFile: function() {
      this.$v.$touch();

      if (!this.$v.$error) {
        this.submitNewFile();
      }
    },
    submitNewFile: function() {
      var that = this;
      if (!this.$v.$error) {
        contractApi
          .postContractFile(this.form, this.selectedFile)
          .then(function() {
            // Toastr Message
            toastr.options = ToastrSettings;
            toastr.success("The contract has been saved.", "Success");

            // redirect
            that.$router.push({
              name: "contract",
              params: { id: that.contractId }
            });
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  components: {
    "tab-item": TabItem
  },
  created() {
    this.form.contractId = this.contractId;
  }
};
</script>

<style scoped>
.span-feedback.invalid-feedback {
  display: block;
}

.invalid-group {
  color: #dc3545;
}
</style>

<style>
label.required:after {
  content: " *";
  color: #dc3545;
  font-weight: bold;
}
.autocomplete__box.form-control {
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
}
.top .vdp-datepicker__calendar {
  position: absolute;
  top: -282px;
}
.file-input + label {
  background-color: #8c1d40;
  border: 1px solid transparent;
}
</style>
